import { ThemeProviderProps } from "../ThemeProvider";
import {
  ComponentPropsWithoutRef,
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
} from "react";
import { LayoutUtilProps } from "../../types";
import { ITranslations } from "../LocalizationProvider/LocalizationProvider";
import { type BreakpointReturnProps } from "../../hooks/useBreakpoint";

export type AnvilProviderProps = ComponentPropsWithoutRef<"div"> &
  LayoutUtilProps & {
    children?: ReactNode;

    themeData?: {
      theme?: ThemeProviderProps["theme"];
      mode?: ThemeProviderProps["mode"];
    };

    localizationData?: {
      locale?: ITranslations["locale"];
      dir?: ITranslations["dir"];
      translations?: ITranslations["translations"];
    };
  } & {
    trackingIdData?: {
      scope?: string;
      optOut?: boolean;
    };
  };

export type AnvilProviderContextProps = {
  breakpoint?: BreakpointReturnProps;
};

export const AnvilProviderContext = createContext<AnvilProviderContextProps>(
  {},
);

export const TooltipLegacyGroupContext = createContext<{
  disableDelayGroup: Dispatch<SetStateAction<boolean>>;
} | null>(null);

export const useTooltipLegacyGroup = () => {
  const context = useContext(TooltipLegacyGroupContext);

  if (context == null) {
    throw new Error(
      "Tooltip components must be wrapped in <AnvilProvider /> or <TooltipGroupContext.Provider />",
    );
  }

  return context;
};
